export default "__VITE_ASSET__ecf113a1__"